import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgFlagIt = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" style={{
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }} viewBox="0 0 2000 1333" sx={{
    ...sx
  }} {...other}><path fill="#009246" d="M-.5-.5h667v1333H-.5z" style={{
      opacity: 1
    }} /><path fill="#fefffe" d="M666.5-.5h666v1333h-666z" style={{
      opacity: 1
    }} /><path fill="#ce2b37" d="M1332.5-.5h667v1333h-667z" style={{
      opacity: 1
    }} /></SvgIcon>;
};
const Memo = memo(SvgFlagIt);
export default Memo;